import { createContext } from 'react';
var DataProviderContext = createContext(null);
DataProviderContext.displayName = 'DataProviderContext';
export default DataProviderContext;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/dataProvider/DataProviderContext.js
// module id = 389
// module chunks = 0